import { useEffect, useState } from 'react';

import {
  resolveAppExperienceMode,
  type AppExperienceMode
} from '@/features/shared/lib/appExperienceMode';

export function useAppExperienceMode(): AppExperienceMode {
  const [mode, setMode] = useState<AppExperienceMode>(() => resolveAppExperienceMode());

  useEffect(() => {
    const displayModeQuery = window.matchMedia('(display-mode: standalone)');
    const viewportQuery = window.matchMedia('(max-width: 767px)');
    const pointerQuery = window.matchMedia('(pointer: coarse)');
    const updateMode = () => setMode(resolveAppExperienceMode());

    displayModeQuery.addEventListener('change', updateMode);
    viewportQuery.addEventListener('change', updateMode);
    pointerQuery.addEventListener('change', updateMode);

    return () => {
      displayModeQuery.removeEventListener('change', updateMode);
      viewportQuery.removeEventListener('change', updateMode);
      pointerQuery.removeEventListener('change', updateMode);
    };
  }, []);

  return mode;
}
